import { studioApi } from './studioApi';

// Private Studio uploads (audio and exports): prepare → presigned PUT → confirm
// with the SHA-256 the server re-checks.

export const baseMimeType = type => (type || '').split(';')[0].trim().toLowerCase();

export async function sha256Hex(blob) {
  const digest = await window.crypto.subtle.digest('SHA-256', await blob.arrayBuffer());
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
}

// `onProgress(0…1)` follows the PUT (a video's, 2.13.0).
export async function uploadAsset(request, blob, { onProgress } = {}) {
  const mimeType = baseMimeType(request.mime_type);
  const sha256 = await sha256Hex(blob);
  const asset = await studioApi.prepareAsset({ ...request, mime_type: mimeType, byte_size: blob.size });
  await studioApi.putUpload(asset.upload, blob, mimeType, onProgress ? { onProgress } : undefined);
  return studioApi.confirmAsset(asset.id, { status: 'uploaded', sha256 });
}
